<label class="esf-form-item__label">{{ label }}<app-optional *ngIf="optional"></app-optional></label>
<quill-editor class="esf-rich-text-editor"
              [styles]="{height: '400px'}"
              [formControl]="formControl"
              [placeholder]="placeholder"
              [modules]="quillModules">
</quill-editor>
